import React, { useState, useEffect } from 'react';

const ScrollToTopButton = () => {
  const [showButton, setShowButton] = useState(false);

  const checkScrollPosition = () => {
    if (window.scrollY > 100) {
      setShowButton(true);
    } else {
      setShowButton(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', checkScrollPosition);

    return () => {
      window.removeEventListener('scroll', checkScrollPosition);
    };
  }, []);

  return (
    showButton && (
        <div className="top_btn">
            <p className="pagetop" onClick={scrollToTop}><img src={'https://www.mandarake.co.jp/recruit/img/pagetop.jpg'} alt='To Top'/></p>
        </div>
    )
  );
};

export default ScrollToTopButton;
